/* eslint-disable eqeqeq */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
/* eslint-disable import/extensions */
/* eslint-disable object-shorthand */
/* eslint-disable prefer-destructuring */
/* eslint-disable dot-notation */
/* eslint-disable prefer-const */
/* eslint-disable arrow-body-style */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-loop-func */
import React, { createContext, useContext } from 'react';
import _ from 'lodash';
import moment from 'moment';


import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import axios from '../../../utils/axios.jsx';
import Yup from '../../../utils/yup.tsx';
import { isNumeric, prepareDate, saveDate, twoDecimalValidation } from '../../../utils/utils.tsx';
import { StatusDokumenta, JedinicaMere } from '../../../utils/enums.tsx';


export const API = 'ponuda';
export const LANGUAGE = API;
export const name = API + 'ReduxSlice';


export const getFields = (t: any, field: string, hideLabel: boolean = false) => {
  let fields: any = [
    {
      id: 'brojDokumenta',
      name: 'brojDokumenta',
      label: hideLabel ? '' : t(LANGUAGE + '.table.brojDokumenta'),
      placeholder: '',
    },
    {
      id: 'napomena',
      name: 'napomena',
      label: hideLabel ? '' : t(LANGUAGE + '.table.napomena'),
      placeholder: '',
    },
    {
      id: 'status',
      name: 'status',
      label: hideLabel ? '' : t(LANGUAGE + '.table.status'),
      placeholder: '',
    },
    {
      id: 'komitent_id',
      name: 'komitent_id',
      label: hideLabel ? '' : t(LANGUAGE + '.table.komitent_id'),
      placeholder: '',
    },
    {
      id: 'lift_id',
      name: 'lift_id',
      label: hideLabel ? '' : t(LANGUAGE + '.table.lift_id'),
      placeholder: '',
    },
    {
      id: 'kategorija_id',
      name: 'kategorija_id',
      label: hideLabel ? '' : t(LANGUAGE + '.table.kategorija_id'),
      placeholder: '',
    },
    {
      id: 'datumPonude',
      name: 'datumPonude',
      label: hideLabel ? '' : t(LANGUAGE + '.table.datumPonude'),
      placeholder: '',
    },
    {
      id: 'rokVazenja',
      name: 'rokVazenja',
      label: hideLabel ? '' : t(LANGUAGE + '.table.rokVazenja'),
      placeholder: '',
    },
    {
      id: 'saPDV',
      name: 'saPDV',
      label: hideLabel ? '' : t(LANGUAGE + '.table.saPDV'),
      placeholder: '',
    },
    {
      id: 'naziv',
      name: 'naziv',
      label: hideLabel ? '' : t(LANGUAGE + '.table.naziv'),
      placeholder: '',
    },
    {
      id: 'kolicina',
      name: 'kolicina',
      label: hideLabel ? '' : t(LANGUAGE + '.table.kolicina'),
      placeholder: '',
    },
    {
      id: 'jedinicaMere',
      name: 'jedinicaMere',
      label: hideLabel ? '' : t(LANGUAGE + '.table.jedinicaMere'),
      placeholder: '',
    },
    {
      id: 'cena',
      name: 'cena',
      label: hideLabel ? '' : t(LANGUAGE + '.table.cena'),
      placeholder: '',
    },
    {
      id: 'roba_id',
      name: 'roba_id',
      label: hideLabel ? '' : t(LANGUAGE + '.table.roba_id'),
      placeholder: '',
    },
    {
      id: 'usluga_id',
      name: 'usluga_id',
      label: hideLabel ? '' : t(LANGUAGE + '.table.usluga_id'),
      placeholder: '',
    },
  ];

  return fields.find((x: any) => x.id === field);
}

export const formSchema = (t: any) => {
  return Yup.object().shape({
    napomena: Yup.string().nullable().label(getFields(t, 'napomena')?.label),
    status: Yup.number().required().label(getFields(t, 'status')?.label),
    komitent_id: Yup.number().required().label(getFields(t, 'komitent_id')?.label),
    lift_id: Yup.number().nullable().label(getFields(t, 'lift_id')?.label),
    kategorija_id: Yup.number().required().label(getFields(t, 'kategorija_id')?.label),

    datumPonude: Yup.date().typeError(t('validacija.typeError')).required().label(getFields(t, 'datumPonude')?.label),
    rokVazenja: Yup.date().typeError(t('validacija.typeError')).required().min(Yup.ref("datumPonude"), t('validacija.min')).label(getFields(t, 'rokVazenja')?.label),

    ponuda_stavke: Yup.array().of(Yup.object().shape({
      naziv: Yup.string().required().label(getFields(t, 'naziv')?.label),
      jedinicaMere: Yup.number().nonNullable().required().min(0).label(getFields(t, 'jedinicaMere')?.label),
      roba_id: Yup.number().nullable().min(0).label(getFields(t, 'roba_id')?.label),
      usluga_id: Yup.number().nullable().min(0).label(getFields(t, 'usluga_id')?.label),
      kolicina: Yup.number().nonNullable().required().min(0).label(getFields(t, 'kolicina')?.label),
      cena: Yup.number().nonNullable().required().label(getFields(t, 'cena')?.label),
    }))
  })
}


let formikContext: any = null;
export const FormikContext = createContext<any>(null);
export const useFormikContext = () => {
    formikContext = useContext(FormikContext);
    if (!formikContext) {
      throw new Error('useFormikContext must be used within a FormikProvider');
    }
    return formikContext;
};


export const preparePayloadForm = (values: any = null, defValues: any = null) => {
  let form = _.cloneDeep(values);
  let data = _.cloneDeep(defValues);

  if(data && form){
    let komitent_id = (form && isNumeric(form.komitent_id)) ? form.komitent_id : null;
    let lift_id = (form && isNumeric(form.lift_id)) ? form.lift_id : null;
    let kategorija_id = (form && isNumeric(form.kategorija_id)) ? form.kategorija_id : null;
    let zahtev_za_radni_nalog_id = (form && isNumeric(form.id)) ? form.id : null;


    data['isActive'] = true;
    data['napomena'] = form?.napomena || '';
    data['status'] = StatusDokumenta.Processing;
    data['komitent'] = form?.komitent || null;
    data['komitent_id'] = komitent_id;
    data['lift'] = form?.lift || null;
    data['lift_id'] = lift_id;
    data['kategorija'] = form?.kategorija || null;
    data['kategorija_id'] = kategorija_id;
    data['ponuda_stavke'] = form?.ponuda_stavke || [];

    data['zahtev_za_radni_nalog_id'] = zahtev_za_radni_nalog_id;
  }

  return data;
};
export const prepareForm = (values: any = null, defValues: any = null) => {
  let form = _.cloneDeep(values);
  let data = _.cloneDeep(defValues);

  if(data && form){
    let komitent_id = (form && isNumeric(form.komitent_id)) ? form.komitent_id : null;
    let lift_id = (form && isNumeric(form.lift_id)) ? form.lift_id : null;
    let kategorija_id = (form && isNumeric(form.kategorija_id)) ? form.kategorija_id : null;

    let stavke = [];
    if(form?.ponuda_stavke && form?.ponuda_stavke.length > 0){
      stavke = form?.ponuda_stavke.map((itm: any, i: number) => {
        return {
          ...itm,
          brojRadnihSati: itm?.usluga?.brojRadnihSati || null,
          marzaNaziv: itm?.roba?.marza?.naziv || null,
        };
      });
    }


    data['brojDokumenta'] = form?.brojDokumenta || '';
    data['isActive'] = form?.isActive || false;
    data['saPDV'] = form?.saPDV || false;
    data['datumPonude'] = prepareDate(form?.datumPonude);
    data['rokVazenja'] = prepareDate(form?.rokVazenja);
    data['napomena'] = form?.napomena || '';
    data['status'] = form?.status || StatusDokumenta.None;
    data['komitent'] = form?.komitent || null;
    data['komitent_id'] = komitent_id;
    data['lift'] = form?.lift || null;
    data['lift_id'] = lift_id;
    data['kategorija'] = form?.kategorija || null;
    data['kategorija_id'] = kategorija_id;
    data['ponuda_stavke'] = stavke;
  }

  return data;
};
export const prepareData = (values: any = null, id: number|null) => {
  let data: any = {};

  if(values){
    let status = (values && isNumeric(values.status)) ? values.status : StatusDokumenta.None;
    let komitent_id = (values && isNumeric(values.komitent_id)) ? values.komitent_id : null;
    let lift_id = (values && isNumeric(values.lift_id)) ? values.lift_id : null;
    let kategorija_id = (values && isNumeric(values.kategorija_id)) ? values.kategorija_id : null;


    let stavke = [];
    if(values?.ponuda_stavke && values?.ponuda_stavke.length > 0){
      stavke = values?.ponuda_stavke.map((itm: any, i: number) => {
        let jedinicaMere = (itm && isNumeric(itm.jedinicaMere)) ? itm.jedinicaMere : JedinicaMere.None;
        let roba_id = (itm && isNumeric(itm.roba_id)) ? itm.roba_id : null;
        let usluga_id = (itm && isNumeric(itm.usluga_id)) ? itm.usluga_id : null;

        let obj: any = {
          naziv: itm?.naziv || '',
          jedinicaMere: jedinicaMere,
          cena: itm?.cena || null,
          kolicina: itm?.kolicina || null,
        };

        if(isNumeric(roba_id)){
          obj['roba_id'] = roba_id;
        }

        if(isNumeric(usluga_id)){
          obj['usluga_id'] = usluga_id;
        }

        return obj;
      });
    }


    data['isActive'] = values?.isActive || false;
    data['saPDV'] = values?.saPDV || false;
    data['datumPonude'] = saveDate(values.datumPonude);
    data['rokVazenja'] = saveDate(values?.rokVazenja);
    data['napomena'] = values?.napomena || '';
    data['status'] = status;
    data['komitent_id'] = komitent_id;
    data['kategorija_id'] = kategorija_id;
    data['lift_id'] = lift_id;
    data['ponuda_stavke'] = stavke;

    if (isNumeric(values.zahtev_za_radni_nalog_id)) {
      data['zahtev_za_radni_nalog_id'] = values.zahtev_za_radni_nalog_id;
    }

    if (isNumeric(id)) {
      data['id'] = id;
    }
  }

  return data;
};


export const getTotal = (values: any, field: string = 'ponuda_stavke') => {
  let total = 0;

  let items = (values && values[field] && values[field].length > 0) ? values[field] : [];
  items.forEach((item: any, i: any) => {
    let kolicina = isNumeric(item.kolicina) ? parseFloat(item.kolicina) : 0;
    let cena = isNumeric(item.cena) ? parseFloat(item.cena) : 0;
    
    total += (kolicina * cena)
  }, 0);

  return parseFloat(total.toFixed(2));
}


export interface initialStavkeStruct {
  naziv: string,
  kolicina: number,
  jedinicaMere: number,
  cena: number|null,
  roba_id: any,
  usluga_id: any,
};
export const initialStavke: initialStavkeStruct = {
  naziv: '',
  kolicina: 1,
  jedinicaMere: JedinicaMere.kom,
  cena: null,
  roba_id: null,
  usluga_id: null,
};


export interface initialValuesStruct {
  isActive: boolean,
  napomena: string,
  status: number,
  datumPonude: any,
  rokVazenja: any,
  komitent_id: any,
  lift_id: any,
  kategorija_id: any,
  ponuda_stavke: Array<any>,
};
export const initialValues: initialValuesStruct = {
  isActive: true,
  napomena: '',
  status: StatusDokumenta.Processing,
  datumPonude: moment().toDate(),
  rokVazenja: moment().add(15, 'd').toDate(),
  komitent_id: null,
  lift_id: null,
  kategorija_id: null,
  ponuda_stavke: [initialStavke]
};


interface InitState {
  isLoading: boolean,
  show: boolean,
  id: number|null,
  payload: any,
  details: any,
  items: Array<any>,
}

function NewReducer() {
  const initialState: InitState = {
    isLoading: false,
    show: false,
    id: null,
    payload: null,
    details: null,
    items: [],
  };


  const reducers = {
    resetSlice: () => {
      return initialState;
    },
    setLoading: (state: InitState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setShow: (state: InitState, action: PayloadAction<{ show: boolean, id: number|null, payload: any }>) => {
      state.id = action.payload.id;
      state.payload = action.payload.payload;
      state.show = action.payload.show;
    },
    setValues: (state: InitState, action: PayloadAction<any>) => {
      state.details = action.payload;
    },

    startRead: (state: InitState) => {
      state.isLoading = true;
      state.items = [];
    },
    finishRead: (state: InitState, action: PayloadAction<any>) => {
      let data = (action.payload && action.payload.data && action.payload.data.length > 0) ? action.payload.data : [];
      state.items = data;
      state.isLoading = false;
    },

    startDetails: (state: InitState) => {
      state.isLoading = true;
    },
    finishDetails: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.details = action.payload;
    },

    startCreate: (state: InitState) => {
      state.isLoading = true;
    },
    finishCreate: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },

    startUpdate: (state: InitState) => {
      state.isLoading = true;
    },
    finishUpdate: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },

    startDelete: (state: InitState) => {
      state.isLoading = true;
    },
    finishDelete: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },
  };


  const apis = {
    callReadApi: (params: any, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startRead());

      await axios.get(API, { params: params }).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, message);
        dispatch(actions.finishRead(data));
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishRead(null));
      });
    },

    callDetailsApi: (id: number|null, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startDetails());

      await axios.get(API + '/' + id).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, '');
        dispatch(actions.finishDetails(data));
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishDetails(null));
      });
    },

    callCreateApi: (params: any, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startCreate());

      await axios.post(API, params).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, message);
        dispatch(actions.finishCreate(data));
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishCreate(null));
      });
    },

    callUpdateApi: (params: any, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startUpdate());

      await axios.put(API + '/' + params?.id, params).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, message);
        dispatch(actions.finishUpdate(data));
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishUpdate(null));
      });
    },

    callDeleteApi: (params: any, callback: (state: boolean, data: any, message: string) => void) => async (dispatch: any) => {
      dispatch(actions.startDelete());

      await axios.delete(API + '/' + params?.id, { data: params }).then((result: any) => {
        const { data, message } = result.data;

        callback(true, data, message);
        dispatch(actions.finishDelete(data));
      }).catch((error: any) => {
        const { message } = error;

        callback(false, null, message);
        dispatch(actions.finishDelete(null));
      });
    },
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
  };
}


export default NewReducer();
